import { Fragment, type ComponentProps } from 'react'
import type { Components, ExtraProps } from 'react-markdown'
import rehypeKatex from 'rehype-katex'
import remarkMath from 'remark-math'
import 'katex/dist/katex.min.css'

/** `$…$` math for `Markdown`, which doesn't ship it: pass these as `remarkPlugins` / `rehypePlugins`. */
export const mathRemarkPlugins = [remarkMath]
export const mathRehypePlugins = [rehypeKatex]

/** Models write a literal `<br>` to break a line inside a table cell. Passes the cell's own props through, so `Markdown`'s column markers and alignment survive. */
const BreakCell = ({ node: _node, children, ...props }: ComponentProps<'td'> & ExtraProps) => {
  if (Array.isArray(children)) {
    return (
      <td {...props}>
        {children.map((child, index) => (
          <Fragment key={index}>{child === '<br>' ? <br /> : child}</Fragment>
        ))}
      </td>
    )
  }
  return <td {...props}>{children}</td>
}

/** `BreakCell` as a `components` map; module-level so the reference is stable across renders. */
export const breakCellComponents: Components = { td: BreakCell }
